/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Iframewidth2Inputs */

const en_entity_iframewidth2 = /** @type {(inputs: Entity_Iframewidth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iFrame Width`)
};

const de_entity_iframewidth2 = /** @type {(inputs: Entity_Iframewidth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iFrame-Breite`)
};

/**
* | output |
* | --- |
* | "iFrame Width" |
*
* @param {Entity_Iframewidth2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_iframewidth2 = /** @type {((inputs?: Entity_Iframewidth2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Iframewidth2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_iframewidth2(inputs)
	return de_entity_iframewidth2(inputs)
});
export { entity_iframewidth2 as "entity_iFrameWidth" }